<template>
  <div id="app" class="oo-module" :class="isSushi && 'montserrat-500'" :style="getloadingBarDone ? getStyle() : ''">
    <component :is="layout">
      <router-view />
    </component>
    <body-skeleton
      v-show="
        (!storeMenu || !getloadedMenu) && !isMobile() && !isInStoreSelection
      "
    />
    <alert-modal></alert-modal>
  </div>
</template>

<script>
const default_layout = "full";
import { mapGetters, mapMutations, mapActions } from "vuex";
import BodySkeleton from "./components/shared/BodySkeleton.vue";
import en from "vee-validate/dist/locale/en";
import zh_CN from "vee-validate/dist/locale/zh_CN";
import { Validator } from "vee-validate";
import store from "../src/store";
import AlertModal from "./components/AlertModal.vue";

export default {
  components: {
    BodySkeleton,
    AlertModal,
  },
  data() {
    return {
      isInStoreSelection: true,
    };
  },
  created() {
    this.setActivePopupState(false);
    let langStr = null;
    if (typeof store.getters.selectedLocale === "object") {
      langStr = store.getters.selectedLocale.locale;
    } else langStr = store.getters.selectedLocale;
    langStr = langStr.replace("-", "_");
    Validator.localize(langStr, langStr == "en" ? en : zh_CN);
    this.setStoreLoading();
    this.initHQDoc();
    this.initTermsAndConditions();
    this.isInStoreSelection = !!this.$route.matched.find((route) => {
      return route.name === "mainpage";
    });
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
    ...mapGetters([
      "desktopStyles",
      "selectedCompany",
      "getloadingBarDone",
      "storeMenu",
      "getloadedMenu",
        "hqDoc"
    ]),
    isSushi() {
      return this.hqDoc && this.hqDoc.IsSushiHub;
    }
  },
  watch: {
    $route() {
      this.isInStoreSelection = !!this.$route.matched.find((route) => {
        return route.name === "mainpage";
      });
    },
  },
  mounted() {
    let langStr = store.getters.selectedLocale;
    langStr = langStr.replace("-", "_");
    Validator.localize(langStr, langStr == "en" ? en : zh_CN);
    const { EmbeddedJavascript } = this.selectedCompany;
    if (EmbeddedJavascript) {
      this.appendInnerHTML(document.head, EmbeddedJavascript);
    }
  },
  methods: {
    ...mapMutations(["setStoreLoading", "setActivePopupState"]),
    ...mapActions(["initHQDoc", "initTermsAndConditions"]),
    getStyle() {
      var style = [];
      if (!this.isMobile()) {
        style.push(this.desktopStyles.primaryBodyBackground);
      }
      return style;
    },
    appendInnerHTML(elm, html) {
      elm.innerHTML = elm.innerHTML + html;
      Array.from(elm.querySelectorAll("script")).forEach((oldScript) => {
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach((attr) =>
          newScript.setAttribute(attr.name, attr.value)
        );
        newScript.appendChild(document.createTextNode(oldScript.innerHTML));
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });
    },
  },
};
</script>
